/** Display helpers shared by the views. Dates are YYYY-MM-DD calendar days; instants are shown in Central time. */
import { html, type TemplateResult } from 'lit-html';

const dayFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
const instantFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

/** "2026-10-20" -> "Oct 20, 2026" (the canvas "mmm d, yyyy"). */
export function day(iso: string | null | undefined): string {
  if (!iso) return '';
  return dayFmt.format(new Date(`${iso}T00:00:00Z`));
}

/** An instant -> "Oct 14, 2026, 9:15 PM CT". */
export function instant(iso: string | null | undefined): string {
  if (!iso) return '';
  return `${instantFmt.format(new Date(iso))} CT`;
}

/** Status pill (the canvas colours: Complete / In Progress / Not Started). */
export function statusPill(status: string): TemplateResult {
  const tone = status === 'Complete' ? 'ok' : status === 'In Progress' ? 'busy' : status === 'With issues' ? 'bad' : 'idle';
  return html`<span class="pill pill-${tone}">${status}</span>`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
